import * as React from 'react';

import XUITextInput from '@xero/xui/react/textinput';

interface IFieldProps {
    id: string;
    label: string;
    placeholder?: string;
    defaultValue?: string;
    additionalInformation?: any;
    disabled?: boolean;
    isInvalid?: boolean;
    validationMessage?: string;
    hintMessage?: string;
    maxLength?: number;
    value?: string;
    autoFocus?: boolean;
    onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    onBlur?: (id: string, value: string) => void;
    onChange?: (id: string, value: string) => void;
    refField?: (node: any) => void;
}

export default class Field extends React.Component<IFieldProps> {
    public static defaultProps: Partial<IFieldProps> = {
        disabled: false,
        isInvalid: false,
        maxLength: 255,
        autoFocus: false
    };

    public getRef = () => (node: any) => {
        if (this.props.refField) {
            this.props.refField(node);
        }
    };

    public getValue = () => {
        if (this.props.defaultValue) {
            return {
                defaultValue: this.props.defaultValue,
            };
        }

        return {
            value: this.props.value,
        };
    };

    public onBlur = ({ target: { id, value } }: any) => {
        if (this.props.onBlur) {
            this.props.onBlur(id.split('-control')[0], value);
        }
    };

    public onChange = ({ target: { id, value } }: any) => {
        if (this.props.onChange) {
            this.props.onChange(id.split('-control')[0], value);
        }
    };

    public render() {
        const {
            defaultValue,
            disabled,
            validationMessage,
            hintMessage,
            isInvalid,
            id,
            label,
            maxLength,
            placeholder,
            additionalInformation,
            autoFocus,
        } = this.props;

        const fieldClasses = isInvalid ? '' : 'xui-field-layout';

        return (
            <div className={fieldClasses}>
                <XUITextInput
                    labelId={id}
                    label={label}
                    inputRef={this.getRef()}
                    isInvalid={isInvalid}
                    onBlur={this.onBlur}
                    onChange={this.onChange}
                    validationMessage={isInvalid ? validationMessage : ""}
                    defaultValue={defaultValue}
                    placeholder={placeholder}
                    isDisabled={disabled}
                    onKeyDown={this.props.onKeyDown}
                    hintMessage={hintMessage}
                    inputProps={{
                        ...this.getValue(),
                        maxLength,
                        autoFocus,

                        autoComplete: "off"
                    }}
                    characterCounter={{
                        maxCharCount: maxLength!,
                        validationMessage: validationMessage ? validationMessage : "",
                        characterCounterMessage: (currentCharCount, maxCharCount) => `[Placeholder] ${currentCharCount} out of ${maxCharCount} characters typed`,
                    }}
                />
                {additionalInformation}
            </div>
        );
    }
}
